import { useQuery } from "react-query";
import { getActiveOfficeBMO } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveOfficeBMO = () => {
  return useQuery("GetActiveOfficeBMO", getActiveOfficeBMO, {
    refetchOnWindowFocus: false,
  });
};
